import { COLORS } from '@btime/constants'
import { FilterHandler } from '@btime/react-contexts'
import React from 'react'

// import { PermissionChecker } from '../../session'
import AbsoluteWithMenuSpacePageTemplate from '../../../components/templates/AbsoluteWithMenuSpacePageTemplate'
import Container from '../../../components/structure/Container'
import PageContent from './PageContent'
import PageHeader from './PageHeader'
import Separator from '../../../components/helpers/Separator'

const TriggerCallsListPage = () => {
  return (
    <AbsoluteWithMenuSpacePageTemplate bgColor={COLORS.white}>
      {/* <PermissionChecker ownerOnly> */}
      <Container>
        <FilterHandler tempStorageNamespace="triggerCalls" initialState={{}}>
          <PageHeader />
          <PageContent />
        </FilterHandler>
        <Separator weight={32} />
      </Container>
      {/* </PermissionChecker> */}
    </AbsoluteWithMenuSpacePageTemplate>
  )
}

export default TriggerCallsListPage
